import Image from "next/image";
import BasicBlock from "../shared/basic-block";
import { CDN_URL } from "@/consts";
import { useStrings } from "@/lib/i18n/context";

const EditorDemoSection = () => {
  const s = useStrings();
  return (
    <BasicBlock
      header={s.editorDemo.header}
      mobileHeader={s.editorDemo.mobileHeader}
      headerStyle="leading-none gap-0"
      subHeader={s.editorDemo.subHeader}
      subHeaderStyle="text-[38px] font-semibold md:text-[48px] leading-none text-black"
    >
      <div className="w-full rounded-2xl bg-[#0052B4]/10 p-1 md:p-2">
        <Image
          src={`${CDN_URL}/landing/editor.png`}
          alt="Editor Demo"
          width={2368}
          height={1281}
          draggable={false}
          className="w-full rounded-2xl border border-[#6D9EFF]"
        />
      </div>
    </BasicBlock>
  );
};

export default EditorDemoSection;
